import { Icon } from '@chakra-ui/react';
import React from 'react';

const Boxes = props => {
  return (
    <Icon
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.475 9.37496H13.1083C11.4333 9.37496 10.625 8.63329 10.625 7.09996V3.31663C10.625 1.78329 11.4417 1.04163 13.1083 1.04163H16.475C18.15 1.04163 18.9583 1.78329 18.9583 3.31663V7.09163C18.9583 8.63329 18.1417 9.37496 16.475 9.37496ZM13.1083 2.29163C11.9917 2.29163 11.875 2.60829 11.875 3.31663V7.09163C11.875 7.80829 11.9917 8.11663 13.1083 8.11663H16.475C17.5917 8.11663 17.7083 7.79996 17.7083 7.09163V3.31663C17.7083 2.59996 17.5917 2.29163 16.475 2.29163H13.1083Z"
        fill="currentColor"
      />
      <path
        d="M16.475 18.9583H13.1083C11.4333 18.9583 10.625 18.1417 10.625 16.475V13.1083C10.625 11.4333 11.4417 10.625 13.1083 10.625H16.475C18.15 10.625 18.9583 11.4417 18.9583 13.1083V16.475C18.9583 18.1417 18.1417 18.9583 16.475 18.9583ZM13.1083 11.875C12.125 11.875 11.875 12.125 11.875 13.1083V16.475C11.875 17.4583 12.125 17.7083 13.1083 17.7083H16.475C17.4583 17.7083 17.7083 17.4583 17.7083 16.475V13.1083C17.7083 12.125 17.4583 11.875 16.475 11.875H13.1083Z"
        fill="currentColor"
      />
      <path
        d="M6.89175 9.37496H3.52508C1.85008 9.37496 1.04175 8.63329 1.04175 7.09996V3.31663C1.04175 1.78329 1.85841 1.04163 3.52508 1.04163H6.89175C8.56675 1.04163 9.37508 1.78329 9.37508 3.31663V7.09163C9.37508 8.63329 8.55841 9.37496 6.89175 9.37496ZM3.52508 2.29163C2.40841 2.29163 2.29175 2.60829 2.29175 3.31663V7.09163C2.29175 7.80829 2.40841 8.11663 3.52508 8.11663H6.89175C8.00841 8.11663 8.12508 7.79996 8.12508 7.09163V3.31663C8.12508 2.59996 8.00841 2.29163 6.89175 2.29163H3.52508Z"
        fill="currentColor"
      />
      <path
        d="M6.89175 18.9583H3.52508C1.85008 18.9583 1.04175 18.1417 1.04175 16.475V13.1083C1.04175 11.4333 1.85841 10.625 3.52508 10.625H6.89175C8.56675 10.625 9.37508 11.4417 9.37508 13.1083V16.475C9.37508 18.1417 8.55841 18.9583 6.89175 18.9583ZM3.52508 11.875C2.54175 11.875 2.29175 12.125 2.29175 13.1083V16.475C2.29175 17.4583 2.54175 17.7083 3.52508 17.7083H6.89175C7.87508 17.7083 8.12508 17.4583 8.12508 16.475V13.1083C8.12508 12.125 7.87508 11.875 6.89175 11.875H3.52508Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default Boxes;
